export default {
  lightBlue: "#f1f5f9",
  darkGray: "#555555",
};
